import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import {
  BOOST,
  INDEED,
  JOVEO,
  POOL,
  REACH,
  SPRING,
  TALROO,
  ZIPRECRUITER,
} from '@/types/channels';

export function useCardContent(channel: string) {
  const intl = useIntl();

  return useMemo(() => {
    switch (channel) {
      case BOOST:
        return {
          title: intl.formatMessage({
            defaultMessage: 'Boost My Job',
            description: 'Channel card title: Fountain Boost product name',
          }),
          description: intl.formatMessage({
            defaultMessage:
              'Fountain Boost automatically posts your job to hundreds of job boards.',
            description:
              'Inactive channel card: one-line value prop for automatic multi-board posting',
          }),
        };
      case INDEED:
        return {
          title: intl.formatMessage({
            defaultMessage: 'Post to Indeed',
            description: 'Channel card title: sponsored Indeed integration',
          }),
          description: intl.formatMessage({
            defaultMessage:
              'Directly sponsor your job on Indeed and receive applicants in Fountain.',
            description:
              'Inactive channel card: explain sponsoring on Indeed and applicant flow into Fountain',
          }),
        };
      case SPRING:
        return {
          title: intl.formatMessage({
            defaultMessage: 'Acquire Global Talent',
            description:
              'Channel card title: Spring / global reach product name',
          }),
          description: intl.formatMessage({
            defaultMessage:
              'Fountain Spring provides job-specific recommendations to sponsor openings to thousands of diverse channels.',
            description:
              'Inactive channel card: Spring suggests diverse paid channels per opening',
          }),
        };
      case REACH:
        return {
          title: intl.formatMessage({
            defaultMessage: 'Leverage Fountain Reach',
            description:
              'Channel card title: AI sourcing product Fountain Reach',
          }),
          description: intl.formatMessage({
            defaultMessage:
              'Uncover quality candidates swiftly and precisely with AI-powered sourcing.',
            description:
              'Inactive channel card: value prop for AI candidate sourcing',
          }),
        };
      case JOVEO:
        return {
          title: intl.formatMessage({
            defaultMessage: 'Post to Joveo',
            description:
              'Channel card title: Joveo recruitment marketing integration',
          }),
          description: intl.formatMessage({
            defaultMessage:
              'Joveo is an AI-led, high-performance recruitment marketing platform.',
            description:
              'Inactive channel card: short vendor blurb for Joveo (third party)',
          }),
        };
      case TALROO:
        return {
          title: intl.formatMessage({
            defaultMessage: 'Post to Talroo',
            description: 'Channel card title: Talroo job board integration',
          }),
          description: intl.formatMessage({
            defaultMessage:
              'Talroo is a job board that specializes in finding candidates for tech jobs.',
            description:
              'Inactive channel card: short vendor blurb for Talroo (third party)',
          }),
        };
      case ZIPRECRUITER:
        return {
          title: intl.formatMessage({
            defaultMessage: 'Post to ZipRecruiter',
            description: 'Channel card title: ZipRecruiter integration',
          }),
          description: intl.formatMessage({
            defaultMessage:
              'ZipRecruiter is a one-stop hiring platform for businesses of all sizes.',
            description:
              'Inactive channel card: short vendor blurb for ZipRecruiter (third party)',
          }),
        };
      case POOL:
        return {
          title: intl.formatMessage({
            defaultMessage: 'Launch a Pool campaign',
            description:
              'Channel card title: re-engage past applicants (Pool product)',
          }),
          description: intl.formatMessage({
            defaultMessage:
              'Pool helps you tap into everyone who has ever applied, referred, or worked for you so you can rehire faster.',
            description:
              'Inactive channel card: Pool mines internal applicant/employee history for faster rehire',
          }),
        };
      default:
        return null;
    }
  }, [channel, intl]);
}
